import { axiosInstance } from "../axios";

export const phieuChamDiemNCCApi = {
  create: async (body) => {
    return await axiosInstance.post("/supplier-evaluation/forms", body);
  },
  getAll: async (params) => {
    return await axiosInstance.get("/supplier-evaluation/forms", {
      params,
    });
  },
  getById: async (id) => {
    return await axiosInstance.get(`/supplier-evaluation/forms/${id}`);
  },
  update: async (id, body) => {
    return await axiosInstance.put(`/supplier-evaluation/forms/${id}`, body);
  },
  remove: async (id) => {
    return await axiosInstance.delete(`/supplier-evaluation/forms/${id}`);
  },
  addSupplier: async (formId, body) => {
    return await axiosInstance.post(
      `/supplier-evaluation/forms/${formId}/evaluation`,
      body
    );
  },
  updateSupplier: async (formId, supplierId, body) => {
    return await axiosInstance.put(
      `/supplier-evaluation/forms/${formId}/evaluation/${supplierId}`,
      body
    );
  },
  getSupplierById: async (formId, supplierId, roleId = "") => {
    return await axiosInstance.get(
      `/supplier-evaluation/forms/${formId}/evaluation/${supplierId}?role_id=${roleId}`
    );
  },
  deleteSupplier: async (formId, supplierId) => {
    return await axiosInstance.delete(
      `/supplier-evaluation/forms/${formId}/evaluation/${supplierId}`
    );
  },
  approveSupplier: async (formId, supplierId, body) => {
    return await axiosInstance.put(
      `/supplier-evaluation/forms/${formId}/evaluation/${supplierId}/approve`,
      body
    );
  },
  getSuppliers: async (formId, supplierId) => {
    return await axiosInstance.get(
      `/supplier-evaluation/forms/${formId}/evaluation/${supplierId}/approvers`
    );
  },
};
